import React, { useState } from 'react';
import LevyContractReportTab from './LevyContractReportTab';
import LeaseAgreementReportTab from './LeaseAgreementReportTab';

const MonthlySummaryStatement = () => {
  const [activeTab, setActiveTab] = useState('levy');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'levy':
        return <LevyContractReportTab />;
      case 'lease':
        return <LeaseAgreementReportTab />;
      default:
        return null;
    }
  };

  return (
    <div>
      {/* Main Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'levy' ? 'active' : ''}`}
            onClick={() => setActiveTab('levy')}
          >
            Levy Contracts
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'lease' ? 'active' : ''}`}
            onClick={() => setActiveTab('lease')}
          >
            Lease Agreements
          </button>
        </li>
      </ul>
      <div className="tab-content mt-3">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default MonthlySummaryStatement;